enum DataProtectionTestIds {
  DATA_PROTECTION_FOOTER_LINK = 'dataProtectionFooterLink',
  DATA_PROTECTION_TITLE = 'dataProtectionTitle',
  DATA_PROTECTION_DOWNLOAD_PDF = 'dataProtectionDownloadPdf',
}

export default DataProtectionTestIds
